/* import __COLOCATED_TEMPLATE__ from './flair-row.hbs.js'; */
import { classNames } from "@ember-decorators/component";
import SelectKitRowComponent from "select-kit/components/select-kit/select-kit-row";
const FlairRow = dt7948.c(class FlairRow extends SelectKitRowComponent {}, [classNames("flair-row")]);
export default FlairRow;